// extracted by mini-css-extract-plugin
export default {"wrapper":"thresholds-module___wrapper___efac1d8b","editInputForm":"thresholds-module___editInputForm___c44e94a0","inputStyle":"thresholds-module___inputStyle___e93c640e"};